import type { ReactNode } from 'react';

interface Props {
  title: ReactNode;
  /** one-line muted intro: what this screen is + how to use it (ctAS §6.8) */
  intro?: ReactNode;
  /** right-aligned actions (ghost then primary) */
  actions?: ReactNode;
}

/* ctAS §7 standard page template header row: <h1> 20/800 +
   one-line muted intro + right-aligned actions. Do NOT add a back
   arrow / logout / Home here — those are chrome (header/back bar). */
export default function PageHeader({ title, intro, actions }: Props) {
  return (
    <div className="flex flex-col gap-2 mb-1">
      <div className="flex items-baseline justify-between gap-3 flex-wrap">
        <h1 className="page-title">{title}</h1>
        {actions && <div className="flex items-center gap-2 flex-wrap">{actions}</div>}
      </div>
      {intro && <p className="text-[13px] text-muted leading-relaxed">{intro}</p>}
    </div>
  );
}
